 <div>
  <app-app-bar></app-app-bar>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
 </div>
